<!--
 * @Description: 手风琴页面专用搜索列表 - 所有跳转硬编码到accordion
 * @Author: AI
 * @Date: 2026-05-23
 -->
<template>
    <div class="searchlist">
        <div class="loading" v-if="loading">
            <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
        </div>
        <div v-else>
            <div class="searchlist-con">
                <div class="details-return" @click="goBack()">
                    <img src="../../../assets/back.png">
                </div>
                <template v-if="$i18n.locale === 'zh-CN'">
                    <div class="details-main">
                        <div v-for="(item, index) in datas" :key="index">
                            <div class="details-main-head">
                                <van-cell :title="item[0].createdTime" icon="calendar-o" class="details-main-head-date" />
                            </div>
                            <div class="details-main-body" v-for="(i, id) in item" :key="id">
                                <!-- 有直播链接 -->
                                <div class="meeting-list" v-if="i.url!=null">
                                    <div class="meeting-left">
                                        <van-cell icon="location-o" class="major-title">{{ i.roomName }}</van-cell>
                                        <van-cell icon="orders-o" class="major-title" v-if="i.roomTitle">{{ i.roomTitle }}</van-cell>
                                        <van-cell icon="clock-o" class="major-titles">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="nToBr(i.topic)"></span></van-cell>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">
                                            <div v-for="(m, j) in i.exData" :key="j" class="expert-row">
                                                <span class="expert-role">{{ m.rolename }}</span>
                                                <span
                                                    class="expert-name"
                                                    v-for="(s, k) in m.exname"
                                                    :key="k"
                                                    @click.stop="todetails(m.exid[k])"
                                                >{{ s }}</span>
                                            </div>
                                        </van-cell>
                                    </div>
                                    <div class="meeting-live">
                                        <a :href="i.url" target="_top">观看直播</a>
                                    </div>
                                </div>
                                <!-- 无直播链接，点击跳转accordion -->
                                <div class="meeting-list meeting-list-link" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
                                    <div class="meeting-left">
                                        <van-cell icon="location-o" class="major-title">{{ i.roomName }}</van-cell>
                                        <van-cell icon="orders-o" class="major-title" v-if="i.roomTitle">{{ i.roomTitle }}</van-cell>
                                        <van-cell icon="clock-o" class="major-titles">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="nToBr(i.topic)"></span></van-cell>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">
                                            <div v-for="(m, j) in i.exData" :key="j" class="expert-row">
                                                <span class="expert-role">{{ m.rolename }}</span>
                                                <span
                                                    class="expert-name"
                                                    v-for="(s, k) in m.exname"
                                                    :key="k"
                                                    @click.stop="todetails(m.exid[k])"
                                                >{{ s }}</span>
                                            </div>
                                        </van-cell>
                                    </div>
                                    <div class="meeting-arrow-icon"><img class="arrow" src="../../../assets/arrow-r.png"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="details-main">
                        <div v-for="(item, index) in datas" :key="index">
                            <div class="details-main-head">
                                <van-cell :title="item[0].createdTime" icon="calendar-o" class="details-main-head-date" />
                            </div>
                            <div class="details-main-body" v-for="(i, id) in item" :key="id">
                                <div class="meeting-list" v-if="i.url!=null">
                                    <div class="meeting-left">
                                        <van-cell icon="location-o" class="major-title">{{ i.roomEnName || i.roomName }}</van-cell>
                                        <van-cell icon="orders-o" class="major-title" v-if="i.roomEnTitle || i.roomTitle">{{ i.roomEnTitle || i.roomTitle }}</van-cell>
                                        <van-cell icon="clock-o" class="major-titles">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="i.entopic ? nToBr(i.entopic) : nToBr(i.topic)"></span></van-cell>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">
                                            <div v-for="(m, j) in i.exData" :key="j" class="expert-row">
                                                <span class="expert-role">{{ m.roleenname || m.rolename }}</span>
                                                <span
                                                    class="expert-name"
                                                    v-for="(s, k) in m.exname"
                                                    :key="k"
                                                    @click.stop="todetails(m.exid[k])"
                                                >{{ m.exenname[k] || s }}</span>
                                            </div>
                                        </van-cell>
                                    </div>
                                    <div class="meeting-live">
                                        <a :href="i.url" target="_top">Live</a>
                                    </div>
                                </div>
                                <div class="meeting-list meeting-list-link" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
                                    <div class="meeting-left">
                                        <van-cell icon="location-o" class="major-title">{{ i.roomEnName || i.roomName }}</van-cell>
                                        <van-cell icon="orders-o" class="major-title" v-if="i.roomEnTitle || i.roomTitle">{{ i.roomEnTitle || i.roomTitle }}</van-cell>
                                        <van-cell icon="clock-o" class="major-titles">{{ i.startTime + ' ~ ' + i.endTime }} <span v-html="i.entopic ? nToBr(i.entopic) : nToBr(i.topic)"></span></van-cell>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">
                                            <div v-for="(m, j) in i.exData" :key="j" class="expert-row">
                                                <span class="expert-role">{{ m.roleenname || m.rolename }}</span>
                                                <span
                                                    class="expert-name"
                                                    v-for="(s, k) in m.exname"
                                                    :key="k"
                                                    @click.stop="todetails(m.exid[k])"
                                                >{{ m.exenname[k] || s }}</span>
                                            </div>
                                        </van-cell>
                                    </div>
                                    <div class="meeting-arrow-icon"><img class="arrow" src="../../../assets/arrow-r.png"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- 嘉宾弹窗 - 任务点击跳转accordion -->
        <div class="modal" v-if="modalShow">
            <div class="details-conss">
                <DetailsNews :exid="exid" :introStatus="introShow" taskRoute="accordion" @func="closeGuest"/>
            </div>
        </div>
        <van-popup v-model="showPopuop" :style="{ padding: '10%', fontSize: '14px' }">无相关会议</van-popup>
    </div>
</template>
<script>
import commonJS from '../../../lib/signUp.js'
import DetailsNews from './details-news.vue';
export default {
    name: 'accsearchList',
    props: ['introShow'],
    components: {
        DetailsNews
    },
    data() {
        return {
            loading: false,
            datas: [],
            showPopuop: false,
            commonMethod: {},
            search: '',
            modalShow: false,
        }
    },
    watch: {
        $route(to, from) {
            if (to.query.search != from.query.search) {
                this.search = to.query.search
                this.init()
            }
        },
    },
    created() {
        if (this.$route.query) {
            this.search = this.$route.query.search
            this.init()
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        async init() {
            try {
                this.datas = []
                this.commonMethod = new commonJS()
                this.loading = true
                const { m, search } = this.$route.query
                const _params = Object.assign({
                    m,
                    dateid: 0,
                    roomid: 0,
                    search: String(search),
                })

                const res = await this.$http.initScheduleInfo(_params)

                if (res.Code === 1000) {
                    this.$emit('searchDatas', res.childens)
                    if (res.DateListEntity.length > 0 && res.DateListEntity != null) {
                        let _list = []
                        res.DateListEntity.map((item) => {
                            let _k = []
                            for (let i in item.programListEntity) {
                                let _D = item.programListEntity[i]
                                let { programList } = _D.programs
                                for (let j in programList) {
                                    let _S = programList[j]
                                    let exData = []
                                    for (let s = 0; s < _S.expertList.length; s++) {
                                        exData = this.filterRolename(_S.expertList)
                                    }

                                    programList[j] = {
                                        url: _S.programRoom.url,
                                        exData,
                                        createdTime: this.formatDate(_S.programDate.prodate),
                                        startTime: _S.starttime,
                                        endTime: _S.endtime,
                                        total: item.ProgramCount,
                                        topic: _S.topic,
                                        roomName: _S.programRoom.roomname,
                                        roomTitle: _S.programRoom.roomtitle,
                                        roleName: _S.expertList[0]?_S.expertList[0].exrolemodel.rolename:'',
                                        roomid: _S.programRoom.roomid,
                                        dateid: _S.dateid,
                                        entopic: _S.entopic,
                                        roomEnName: _S.programRoom.roomenname,
                                        roomEnTitle: _S.programRoom.roomentitle,
                                        roleEnName: _S.expertList[0]?_S.expertList[0].exrolemodel.roleenname:'',
                                    }
                                    _k.push(programList[j])
                                }
                            }

                            _list.push(_k)
                        })
                        this.datas = _list
                    } else {
                        this.showPopuop = true
                    }
                }
                this.loading = false
            } catch (error) {
                console.error(error)
            }
        },
        formatTime(val) {
            let et = val.split('(')
            let end = et[1].split(')')[0]
            let endtime = Number(end)
            let date = new Date(endtime)
            let h = date.getHours()
            h = h < 10 ? '0' + h : h
            let m = date.getMinutes()
            m = m < 10 ? '0' + m : m
            return h + ':' + m
        },
        formatDate(val) {
            let et = val.split('(')
            let end = et[1].split(')')[0]
            let date = new Date(Number(end))
            let month = date.getMonth() + 1
            let day = date.getDate()
            return month + '-' + day
        },
        filterRolename(data) {
            let _rolenameList = [],
                _rolename = []

            for (let i in data) {
                _rolename.push(data[i].exrolemodel.rolename)
                let _indexof = _rolenameList.indexOf(_rolename[i])
                if (_indexof == -1) {
                    _rolenameList.push(data[i].exrolemodel.rolename)
                }
            }
            let _identityList = []
            _rolenameList.forEach((item) => {
                let _identity = { rolename: '', exname: [], exid: [], excompany: [], exenname: [], exencompany: [], roleenname: '' }
                let _exname = [],
                    _exid = [],
                    _excompany = [],
                    _exenname = [],
                    _exencompany = [];
                for (let n in data) {
                    if (item === data[n].exrolemodel.rolename) {
                        _exname.push(data[n].exname)
                        _identity.rolename = item
                        _identity.exname = _exname
                        _exid.push(data[n].exid)
                        _identity.exid = _exid
                        _excompany.push(data[n].excompany)
                        _identity.excompany = _excompany
                        _exenname.push(data[n].exenname)
                        _identity.exenname = _exenname
                        _exencompany.push(data[n].exencompany)
                        _identity.exencompany = _exencompany
                        _identity.roleenname = data[n].exrolemodel.roleenname
                    }
                }
                _identityList.push(_identity)
            })

            return _identityList
        },
        todetails(param) {
            this.modalShow = true
            this.exid = param
        },
        // 所有结果点击 → 跳转accordion
        goMeeting(e, dateid, roomid) {
            const { m, language } = this.$route.query
            const params = { m, roomid, dateid }
            if (language !== undefined) { params.language = language }
            this.$router.push({ name: 'scheduleAccordion', query: params })
        },
        closeGuest(){
          this.modalShow = false
        },
        nToBr (str){
            if( str ){
                return str.replace(/\\n/g,'<br/>');
            }else{
                return str
            }
        },
    },
}
</script>
<style lang="scss">
.searchlist {
    .van-cell {
        &::after {
            width: 95%;
            margin: 0 auto;
            left: 0;
        }
    }
}

.modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 1000;
    .details-conss {
        background: #fff;
        margin-bottom: 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 10001;
        transform: translate(-50%, -50%);
        width: 90%;
        height: 80%;
        overflow-y: auto;
        border-radius: 12px;
    }
}
</style>
<style lang="scss" scoped>
.searchlist {
    width: 100%;
    height: auto;

    .details-return {
        position: fixed;
        right: 0;
        bottom: 80px;
        width: 84px;
        height: 60px;
        z-index: 100;
        background: #3b82f6;
        border-radius: 30px 0 0 30px;
        text-align: center;
        line-height: 60px;
        color: #fff;
        img { height: 100%; }
    }

    .searchlist-con {
        padding: 20px;
    }

    .details-main {
        > div {
            background: #fff;
            margin-bottom: 24px;
            border-radius: 12px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
            overflow: hidden;
        }

        .details-main-head {
            padding: 24px 20px 10px;
            display: flex;
            .details-main-head-date {
                color: #3b82f6;
                font-size: 30px;
                font-weight: 600;
                padding: 0;
                & > .van-icon { font-size: 40px; line-height: 40px; color: #3b82f6; }
                &:after { border: none; }
                span { line-height: 40px; }
            }
            .van-cell { background: none; }
        }

        .details-main-body {
            padding: 0 20px 16px;
        }

        .meeting-list {
            display: flex;
            margin-bottom: 14px;
            padding: 18px 20px 18px 22px;
            position: relative;
            border-left: 4px solid #3b82f6;
            background: #f8fafc;
            border-radius: 0 8px 8px 0;

            &:last-child { margin-bottom: 0; }

            &.meeting-list-link:active { background: #e8f0fe; }

            .meeting-left { flex: 1; min-width: 0; }

            .major-title {
                padding: 8px 0;
                font-size: 26px;
                color: #1e293b;
                line-height: 36px;
                > i { width: 36px; font-size: 36px; line-height: 36px; color: #3b82f6; }
                > div { color: #1e293b; }
                &:after { border: 0; }
            }

            .major-titles {
                padding: 8px 140px 8px 0;
                font-size: 26px;
                color: #1e293b;
                line-height: 36px;
                > i { width: 36px; font-size: 36px; line-height: 36px; color: #3b82f6; }
                > div { color: #1e293b; }
                &:after { border: 0; }
            }

            .meeting-live {
                position: absolute;
                right: 0;
                top: 18px;
                z-index: 10;
                background: linear-gradient(135deg, #3b82f6, #6366f1);
                padding: 8px 22px 8px 24px;
                border-radius: 50px 0 0 50px;
                a { color: #fff; font-size: 22px; text-decoration: none; }
            }

            .meeting-arrow-icon {
                width: 50px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                img { width: 90%; }
            }
        }
    }

    .expert-row {
        margin-bottom: 6px;
        line-height: 1.6;
        .expert-role { font-size: 24px; color: #64748b; margin-right: 8px; }
        .expert-name {
            font-size: 24px;
            color: #3b82f6;
            margin-right: 12px;
            cursor: pointer;
            display: inline-block;
            &:after { content: '、'; color: #94a3b8; }
            &:last-child:after { content: ''; }
        }
    }
}
</style>
